import { render, staticRenderFns } from "./PGHome.vue?vue&type=template&id=34094ca0&scoped=true"
import script from "./PGHome.vue?vue&type=script&lang=js"
export * from "./PGHome.vue?vue&type=script&lang=js"
import style0 from "./PGHome.vue?vue&type=style&index=0&id=34094ca0&prod&lang=scss&scoped=true"
import style1 from "./PGHome.vue?vue&type=style&index=1&id=34094ca0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34094ca0",
  null
  
)

export default component.exports